<template lang="html">
<div id="buildings">
    <el-row class="headLine">
        <!-- 新建 -->
        <el-col :span="12" style="text-align:left;">
            <el-button @click="goInner(2)"  size="small" type="primary">新建</el-button>
        </el-col>
        <!-- 选择器 -->
        <div class="headright">
            <el-select v-model="status" placeholder="状态" size="small" @change="statusChange" clearable>
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input v-model="searchText" placeholder="标题搜索" class="input" size="small">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
        </div>
    </el-row>
    <List ref="list" />
</div>
</template>

<script>
import List from './src/list';

// import { getBuildings } from '@/api/industryInfos';
export default {
    components: {
        List
    },
    data() {
        return {
           
            searchText:'',
            status:'',
            options: [{
                    value: 1,
                    label: '启用'
                },
                {
                    value: 2,
                    label: '禁用'
                },
            ],
        }
    },
    methods: {
        statusChange(e){
            var param={
                status:e,
            };
            this.$refs.list.search(param);
        },
        search(){
            var param={
                name:this.searchText,
            };
            this.$refs.list.search(param);
        },
        // 新建
        goInner(flag) {
            var querys={};
            querys.type=flag;
            this.$router.push({
                path: '/cms_user/add_lawyer_library',
                query: querys
            });
        },
    },
    created() {

    }

}
</script>

<style lang="scss" scoped>
#buildings {
    font-size: 15px;
    background-color: #f5f5f5;
    min-height: 500px;

    .headLine {
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #ebeef5;
        background-color: #fff;
    }

    .seLect {
        width: 110px;
    }

    .headright {
        text-align: right;
        margin-right: 10px;

        .input {
            width: 260px;
            border-radius: none;
        }
    }
}
</style>

<style lang="css">
.headright .el-input__inner {
    border-radius: 0px !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?5a3cc9f5